import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const Team1 = ({
  heading = "Meet Our Team",
  description = "The passionate minds behind DMLS.",
}) => {
  // Team member data
  const teamMembers = [
    {
      id: "anand-lo",
      name: "Anand Lo",
      role: "President",
      image: `${process.env.PUBLIC_URL}/AnandLo_Anand Lo.jpeg`,
      initials: "AL",
    },
    {
      id: "het-jivani",
      name: "Het Jivani",
      role: "Internal Vice President",
      image: `${process.env.PUBLIC_URL}/Het_Jivani_digital_photo.jpeg`,
      initials: "HJ",
    },
    {
      id: "kai-patel",
      name: "Kai Patel",
      role: "External Vice President",
      image: `${process.env.PUBLIC_URL}/KP.png`,
      initials: "KP",
    },
    {
      id: "rafat-hossain",
      name: "Rafat Hossain",
      role: "Treasurer",
      image: `${process.env.PUBLIC_URL}/Rafat.jpg`,
      initials: "RH"
    },
    {
      id: "shuvro-pal",
      name: "Shuvro Pal",
      role: "Events coordinator",
      image: `${process.env.PUBLIC_URL}/headshot_Shuvro Pal.png`,
      initials: "SP"
    },
    {
      id: "nafisah-nubah",
      name: "Nafisah Nubah",
      role: "Lead of Events and Social Media",
      image: `${process.env.PUBLIC_URL}/headshot-nubah_Nafisah Nubah.jpg`,
      initials: "NN"
    },
    {
      id: "chizulu-zephaniah",
      name: "Chizulu Zephaniah",
      role: "Web Developer",
      image: `${process.env.PUBLIC_URL}/Chizulu.jpg`,
      initials: "CZ"
    },
    {
      id: "akash-maity",
      name: "Akash Maity",
      role: "Student Representative",
      image: `${process.env.PUBLIC_URL}/Akash.jpg`,
      initials: "AM"
    },
    {
      id: "sophie-eruokwu",
      name: "Sophie Eruokwu",
      role: "Mentorship Lead",
      image: `${process.env.PUBLIC_URL}/Sophie.jpg`,
      initials: "SE"
    },
  ];
  const navigate = useNavigate();

  const handleMemberClick = (memberId) => {
    navigate(`/team/${memberId}`);
  };

  return (
    <section className="py-32 bg-transparent">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col items-center text-center mb-16">
          <div className="flex items-center justify-center gap-2 px-4 py-2 bg-white rounded-full border-2 border-[#0395fc] shadow-sm w-fit mx-auto mb-6">
            <span className="font-bold text-sm font-[var(--font-dm-sans)]" style={{ color: '#0395fc' }}>Leadership</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-black font-[var(--font-anton)] leading-tight mb-4">
            <span className="block text-foreground">OUR</span>
            <span className="block" style={{ color: '#0395fc' }}>TEAM</span>
          </h2>
          <div className="h-2 w-24 bg-[#0395fc] transform -skew-x-12 mx-auto mb-6"></div>
          <p className="text-muted-foreground max-w-3xl lg:text-xl font-[var(--font-dm-sans)] leading-relaxed">
            {description}
          </p>
        </div>
        
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {teamMembers.map((member, index) => (
            <motion.div 
              key={member.id} 
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              onClick={() => handleMemberClick(member.id)}
              className="flex flex-col items-center bg-white p-6 border-2 border-black shadow-[6px_6px_0px_0px_rgba(0,0,0,1)] hover:shadow-[3px_3px_0px_0px_rgba(0,0,0,1)] hover:translate-x-1 hover:translate-y-1 transition-all duration-200 cursor-pointer group"
            >
              {/* Member Image */}
              <div className="relative w-24 h-24 lg:w-32 lg:h-32 rounded-full overflow-hidden mb-4 border-2 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] group-hover:shadow-[2px_2px_0px_0px_rgba(0,0,0,1)] transition-all duration-200">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.onerror = null;
                    // Fallback to initials if image fails to load
                    e.target.parentElement.innerHTML = `<div class="w-full h-full bg-[#0395fc] flex items-center justify-center">
                      <span class="text-white font-black text-xl lg:text-2xl font-[var(--font-anton)]">
                        ${member.initials}
                      </span>
                    </div>`;
                  }}
                />
                <div className="absolute inset-0 bg-[#0395fc]/5 group-hover:bg-[#0070c0]/10 transition-colors duration-300"></div>
              </div>
              
              <h3 className="text-center font-black font-[var(--font-anton)] text-lg lg:text-xl mb-2 text-foreground">
                {member.name}
              </h3>
              <p className="text-center text-[#0395fc] font-bold font-[var(--font-dm-sans)] text-sm uppercase tracking-wider">
                {member.role}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team1;